import actions from "./actions";
import { default as NotificationsReducer, sliceActions } from "./reducer";

export { default as NotificationsSelectors } from "./selectors";
export { default as NotificationsSaga } from "./sagas";
export { default as NotificationThunks } from "./thunks";

const NotificationActions = { ...actions, ...sliceActions };
export { NotificationsReducer, NotificationActions };
